export function getSplitIOKey(
    host = 'dev.evbqa.com',
    apiKeyConfig: SplitIOApiKeyConfig,
) {
    if (host.indexOf('eventbrite') > -1) {
        return apiKeyConfig.prodKey;
    }

    if (host.indexOf('dev') > -1) {
        return apiKeyConfig.devKey;
    }

    if (host.indexOf('evbqa') > -1) {
        return apiKeyConfig.qaKey;
    }

    return apiKeyConfig.devKey;
}

export type SplitIOApiKeyConfig = {
    // NOTE: The workspace does not need to match with the one in the SplitIO,
    // it is only used to store the client object. However, we encourage you to write
    // your workspace name to avoid overrides with other teams' clients.
    workspace: string;
    prodKey: string;
    qaKey: string;
    devKey: string;
};
